import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgSliderArrowDown({
  className,
  "data-test-id": dataTest = "IconSliderArrowDown",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx("polygon", { fill: "currentColor", points: "12 14 6 8 4.5 9.5 12 17 19.5 9.5 18 8" }) }) });
}));
